import { memo } from 'react';
import styled from 'styled-components';
import Link from 'next/link';

const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1;
  margin-bottom: 1rem;
  position: relative;
  text-align: center;
  text-transform: uppercase;
`;

const Anchor = styled.a`
  color: var(--theme-color-section);
  display: block;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

type SectionTitleProps = {
  children: React.ReactNode;
  url: string;
};

const SectionTitle = ({ children, url }: SectionTitleProps) => {
  return (
    <Title>
      <Link href={url} passHref legacyBehavior>
        <Anchor>{children}</Anchor>
      </Link>
    </Title>
  );
};

export default memo(SectionTitle);
